module.exports = __webpack_public_path__ + "img/bg_blue_left.9f67347e.png";